import type { FunctionalComponent } from 'vue'

import {
  BarChart3,
  BookOpenCheck,
  Cog,
  File,
  FileText,
  FolderPlus,
  Shield,
  User,
  Users,
} from 'lucide-vue-next'

import { routeNames, type RouteNameValues } from '@/router/routeNames'
import { busLogsPermissions } from '@/services/api/logs'
import { userPermissions } from '@/services/api/users'

export interface DashboardSectionItem {
  title: string
  description: string
  name: RouteNameValues
  icon: FunctionalComponent
}

interface DashboardSectionConfig extends DashboardSectionItem {
  canView: (permissions: string[]) => boolean
}

const sections: DashboardSectionConfig[] = [
  {
    title: 'common.route.statistics',
    description: 'dashboard.sections.statisticsDesc',
    name: routeNames.Statistics,
    icon: BarChart3,
    canView: () => true,
  },
  {
    title: 'common.route.flows',
    description: 'common.menu.configurationDesc',
    name: routeNames.Flows,
    icon: Cog,
    canView: () => true,
  },
  {
    title: 'common.route.createConfiguration',
    description: 'common.menu.configurationNewDesc',
    name: routeNames.ConfigurationNew,
    icon: FolderPlus,
    canView: () => true,
  },
  {
    title: 'common.route.files',
    description: 'common.menu.filesDesc',
    name: routeNames.Files,
    icon: File,
    canView: () => true,
  },
  {
    title: 'common.route.users',
    description: 'common.menu.usersDesc',
    name: routeNames.Users,
    icon: Users,
    canView: permissions => permissions.includes(userPermissions.VIEW_ALL),
  },
  {
    title: 'common.route.roles',
    description: 'common.menu.rolesDesc',
    name: routeNames.Roles,
    icon: Shield,
    canView: () => true,
  },
  {
    title: 'common.route.configurationFinished',
    description: 'common.menu.configurationFinishedDesc',
    name: routeNames.ConfigurationsFinished,
    icon: BookOpenCheck,
    canView: () => true,
  },
  {
    title: 'common.route.profile',
    description: 'dashboard.sections.profileDesc',
    name: routeNames.Profile,
    icon: User,
    canView: () => true,
  },
  {
    title: 'common.route.logs',
    name: routeNames.Logs,
    description: 'common.menu.logsDesc',
    icon: FileText,
    canView: permissions => permissions.includes(busLogsPermissions.VIEW_ANY),
  },
]

export const getDashboardSections = (
  permissions: string[]
): DashboardSectionItem[] => {
  return sections.filter(section => section.canView(permissions))
}
